import yall from 'yall-js';
import Events from "./Components/Core/Events";
import Forms from "./Components/Forms/forms";
import {favoritesInit, favoritesInitItem} from "./Components/Favorites/favorites";
import {compareInitItem} from "./Components/Compare/compare";
import Locations from './Components/Locations/locations';
import {cartInfoInit} from "./Components/basket/updateCartInfo";
import MmenuLight from "mmenu-light";
import Agent from "./Components/Core/agent";
import {searchAutocomplete} from "./Components/Search/search";
import {modal} from "./Components/UI/modal";
import {notice} from "./Components/UI/notice";
import {empty} from "./Components/Core/common";
import AuthApi from "./Components/Api/AuthApi";

const events = new Events();

cartInfoInit(events);

const form = new Forms(events);
let locations = new Locations(events);

document.querySelectorAll('.geo_location').forEach(item => item.addEventListener('click', () => {
    locations.getLocations(item);
}));

favoritesInit('.js_add_favorites', events);
//compareInit('.js_add_compare', events);


let initBasket;
if (document.querySelector('.js_add_to_cart')) {
    if (!initBasket) {
        initBasket = async () => await import("./Components/basket/basket");
    }

    initBasket()
        .then(f => f.initBasketEvents('.js_add_to_cart', events));
}

document.querySelectorAll('.spoiler').forEach(item => {
    let btn = item.querySelector('.spoiler-btn');
    let block = item.querySelector('.spoiler-block');
    btn.addEventListener('click', () => {
        btn.classList.toggle('active');
        if(!block.classList.contains('active')){
            if(item.closest('.spoiler-group')){
                item.closest('.spoiler-group').querySelectorAll('.spoiler').forEach(groupItem => {
                    let block = groupItem.querySelector('.spoiler-block');
                    let btn = groupItem.querySelector('.spoiler-btn');
                    if(groupItem !== item){
                        block.style.height = '0px';
                        setTimeout(function () {
                            block.classList.remove('active');
                            btn.classList.remove('active');
                            groupItem.classList.remove('active');
                        }, 350);
                    }
                })
            }
            item.classList.toggle('active');
            block.classList.add('active');
            block.style.height = 0;
            block.style.height = block.scrollHeight + 'px';
        } else {
            block.style.height = '0px';
            setTimeout(function () {
                block.classList.remove('active');
                item.classList.toggle('active');
            }, 350);
        }
    });
});
document.querySelectorAll('.dropdawn').forEach(item => {
    item.addEventListener("mouseover", function () {
        item.querySelector('.dropdawn-btn').classList.add('active');
        item.querySelector('.dropdawn-menu').classList.add('active');
    });
    item.addEventListener("mouseleave", function () {
        let timer = setTimeout(function () {
            item.querySelector('.dropdawn-menu').classList.remove('active');
            item.querySelector('.dropdawn-btn').classList.remove('active');
        }, 100);
        item.addEventListener('mouseover', function () {
            item.querySelector('.dropdawn-btn').classList.add('active');
            item.querySelector('.dropdawn-menu').classList.add('active');
            clearTimeout(timer);
        });
    });
});

let reInitBasket;
events.addListener('filter.search', null, () => {
    document.querySelectorAll('.js_add_favorites').forEach(item => favoritesInitItem(item));
    document.querySelectorAll('.js_add_compare').forEach(item => compareInitItem(item));
    if (!reInitBasket) {
        if (!initBasket) {
            initBasket = async () => await import("./Components/basket/basket");
        }

        initBasket().then(f => {
            reInitBasket = f.reInitBasketEvents;
            reInitBasket('.js_add_to_cart', events);
        });
    } else {
        reInitBasket('.js_add_to_cart', events);
    }


    form.initModalForm(document);

    document.querySelectorAll('.product-item').forEach(item => {
        if (!item.classList.contains('btn-char-initialized')) {
            item.classList.add('btn-char-initialized');
            let btn_char = item.querySelector('.btn-char');
            if (btn_char) {
                btn_char.addEventListener('click', () => {
                    item.querySelector('.flip-container').classList.toggle('active');
                });
            }
            let flip_close = item.querySelector('.flip-close');
            if (flip_close) {
                flip_close.addEventListener('click', () => {
                    item.querySelector('.flip-container').classList.remove('active');
                });
            }
        }
    });
});

if (document.querySelector('.js_filter_form')) {
    const filter = async () => await import("./Components/Filter/filter");
    filter().then(f => f.init(events));
}

yall({
    observeChanges: true,
    events: {
        load: function (event) {
            if (!event.target.classList.contains("lazy") && event.target.nodeName === "IMG") {
                event.target.classList.add("yall-loaded");
            }
        },
        play: function (event) {
            if (event.target.nodeName === "VIDEO") {
                event.target.nextElementSibling.classList.add("visible");
            }
        }
    }
});

let mobile_menu = document.querySelector("#mobile-menu");
if (mobile_menu) {
    let mobileMenu = new MmenuLight(mobile_menu);
    mobileMenu.navigation({
        title: "Меню",
        theme: "dark"
    });
    let drawerMenu = mobileMenu.offcanvas();
    document.querySelector('a[href="#mobile-menu"]').addEventListener('click', function (evnt) {
        evnt.preventDefault();
        drawerMenu.open();
    });
}


if (document.querySelector('input[type="tel"]')) {
    let phoneFormatter = async () => await import('./Components/phone');
    phoneFormatter().then(e => e.init());
}

if (document.querySelector('.scroll-item')) {
    document.addEventListener('scroll', () => {
        if (window.pageYOffset > 300) {
            document.querySelectorAll('.scroll-item').forEach(item => {
                item.classList.add('active');
            });
        } else {
            document.querySelectorAll('.scroll-item').forEach(item => {
                item.classList.remove('active');
            });
        }
    });
    document.querySelector('.scroll-item').addEventListener('click', () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    });
}

if (document.querySelector('.category-filter')) {
    let btn = document.querySelector('.btn-filter');
    let filter = document.querySelector('.category-filter');
    document.addEventListener('click', (e) => {
        if (filter.classList.contains('active')) {
            if (e.target === filter) {
                filter.classList.remove('active');
            }
        }
    });
    btn.addEventListener('click', () => {
        filter.classList.add('active');
    });
}

const loadViewed = document.querySelector('.viewed');
if (loadViewed) {
    let observer = new IntersectionObserver((entries, obs) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                if (!loadViewed.querySelector('div')) {
                    Agent.post(`/api/v1/viewed`)
                        .then(e => e.json())
                        .then(e => {
                            if (e.success) {
                                loadViewed.innerHTML = e.data;
                                events.dispatch('filter.search');
                            }
                        })
                        .catch(e => console.log(e))
                        .finally(() => {
                            obs.unobserve(entry.target);
                        });
                }
            }
        });
    });

    observer.observe(loadViewed);
}

if (document.querySelector('.search-field')) {
    searchAutocomplete.init();
}

document.querySelectorAll('.js_open_autorize_form').forEach(item => item.addEventListener('click', () => {
    const options = {
        header: function () {
            return `<div class="modal-header">
                ${this.closeBtm}</div>`;
        },
        'closeBtm': `<button class="btn-close position-absolute end-0 top-0 border-0 ms-auto d-flex bg-transparent" data-bs-dismiss="modal"><i class="icon close text-main"></i></button>`,
        'size': 'modal-dialog-centered modal-sm',
        message: `<div class="modal-top">
                    <h3 class="fs-md-30 fs-20 fw-bl lh-1 mb-0">Вход и регистрация</h3>
                    <p>Мы отправим SMS с кодом на указанный номер телефона</p>
                </div>
                <div class="modal-bottom">
                    <form class="d-flex flex-column gap-20" name='authorization' method='post' autocomplete="off">
                        <label class="main-input position-relative">
                            <input class="px-xl-30 px-20 py-xl-20 py-15 fs-14" type="tel" name="phone" placeholder="+7 (9__) ___-__-__" required>
                            <button 
                                class="btn-inline position-absolute top-50 end-0 translate-middle-y fs-14 fw-sb text-main me-xl-30 me-20 bg-white js_recover_password"
                                type="button"
                            >
                                Получить код
                            </button>
                        </label>
                        <div class="concat-input">
                            <label class="main-input">
                                <input class="px-xl-30 px-20 py-xl-20 py-15 fs-14" type="password" placeholder="SMS-код" name="password" required>
                            </label>
                            <button class="btn btn-main px-xl-30 px-20 py-xl-20 py-15 fs-14 fw-sb js_auth_button">Войти</button>
                        </div>
                        <div class="message w-100 d-flex justify-content-center">
                            <span class="fw-regular fs-14 text-danger js_message_label"></span>
                            <span class="fw-regular fs-14 text-danger js_message_sms_label d-none"> </span>
                        </div>
                    </form>
                </div>`,
        showEvent: function (to) {

            let inputPhone = to.querySelector('input[name="phone"]');
            let inputPassword = to.querySelector('input[name="password"]');
            let js_recover_password = to.querySelector('.js_recover_password');

            let js_message_label = to.querySelector('.js_message_label');
            let js_message_sms_label = to.querySelector('.js_message_sms_label');
            let form = to.querySelector('form');
            let js_auth_button = to.querySelector('.js_auth_button');

            const authorization = function () {
                js_message_label.innerHTML = '';

                let userName = inputPhone.value.trim().replace(/[^0-9]/g, '');
                let password = inputPassword.value.trim();

                if (empty(userName) || empty(password)) {
                    notice("Необходимо заполнить<br> обязательные поля.");
                    return;
                }

                AuthApi.authorization(userName, password)
                    .then(response => response.json())
                    .then(response => {
                        if (response.success) {
                            if (response.url) {
                                document.location.href = response.url;
                            } else {
                                document.location.reload();
                            }
                        } else {
                            js_message_label.innerHTML = response.message;
                        }
                    })
                    .catch(() => {
                        notice("Не удалось сменить пароль.<br> Попробуйте позже <br>или<br> обратитесь к администратору.");
                    });
            };

            const timer = (timerPeriod, start, tick, finish) => {
                let counter = timerPeriod || 1;
                if (typeof start === 'function') {
                    start();
                }
                if (typeof tick === 'function') {
                    tick(counter);
                }
                let smsTimer = setInterval(function () {
                    counter--;
                    if (typeof tick === 'function') {
                        tick(counter);
                    }
                    if (counter === 0) {
                        counter = timerPeriod;
                        clearInterval(smsTimer);
                        if (typeof finish === 'function') {
                            finish();
                        }
                    }
                }, 1000);
            };

            const smsTimer = seconds => {
                timer(parseInt(seconds), function () {
                    js_recover_password.disabled = true;
                    js_message_sms_label.classList.remove('d-none');
                }, function (secondsLeft) {
                    js_message_sms_label.innerHTML = `Пароль был выслан на указанный номер. <br>Следующая отправка СМС возможна через <b>${secondsLeft}</b> секунд`;
                }, function () {
                    js_recover_password.disabled = false;
                    js_message_sms_label.classList.add('d-none');
                });
            };

            const recover_password = function () {

                let phone = inputPhone.value.trim().replace(/[^0-9]/g, '');
                if (empty(phone)) {
                    notice("Необходимо заполнить<br> обязательные поля.");
                } else {
                    js_recover_password.classList.add('preloader');
                    AuthApi.recoverPassword(phone)
                        .then(response => response.json())
                        .then(response => {
                            if (response.message && !response.seconds) {
                                js_message_label.innerHTML = response.message;
                            }
                            if (response.seconds) {
                                smsTimer(response.seconds);
                            }
                        })
                        .catch(() => {
                            notice("Не удалось отправить пароль.<br> Попробуйте позже<br> или<br> обратитесь к администратору.");
                        })
                        .finally(() => {
                            js_recover_password.classList.remove('preloader');
                        });
                }
            };


            inputPhone.addEventListener('input', () => {
                js_message_label.innerHTML = '';
            });

            js_auth_button.addEventListener('click', () => {
                js_message_label.innerHTML = '';

                if (inputPassword.value.trim().length > 3) {
                    authorization();
                }
            });

            js_recover_password.addEventListener('click', () => {
                js_message_label.innerHTML = '';
                recover_password();
            });

            form.addEventListener('submit', event => {
                event.stopPropagation();
                event.preventDefault();
            });
        }
    };

    modal(options);
}));
export default events;